import React from "react";
import OPTIONS from "../../../../constant/Option";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";

import {
  EditableTextField,
  EditableSelectField,
  RadioOptions,
  EditableMultiSelectField,
} from "../../../../Global_Component/CustomInputComponent";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Chip,
  Autocomplete,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import { useState } from "react";
import { CustomFileUpload } from "../../../../Global_Component/customFileUplodComponent";
const ProductSpecification = () => {
    const [isEdit,setIsEdit]=useState(false)
    const [productDetail,setProductDetail]=useState({
        name:"Protien Bar",
        brandName:"SavoryBites",
        productCategory:"Egg and egg Products",
        productDescription:" sdkdjjd sksjd dhjs sjsjs sks ssj sjsjsh shshs sjsns sjsj ",
        productApplication:"ksnsj djdn sjd slkdn sknd skndns ksn ssjnd ns djknf anks "
    })





  const sidebarItems = [
    "Protein bar",
    "Sprinkles",
    "Chicken Chips",
    "Protein chocolate google .com",
  ];
  const ingredients = [
    {
      category: "Raw Material",
      options: ["Oats", "Eggs", "Whole wheat", "Beef steak", "Milk", "Curd"],
    },
    {
      category: "Additive & Excipients",
      options: ["Lactose", "Spray dried lactose", "Dextrose", "Sucrose"],
    },
    {
      category: "Processing Aids & Solvents",
      options: ["Sodium sterol lactylate", "Antimicrobial agents"],
    },
  ];

  //   const sidebarItems = ["Dashboard", "Profile", "Settings", "Logout"];
  const [selectedIndex, setSelectedIndex] = useState(0); // Keep track of selected index

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };






  const [formData, setFormData] = useState({
    ingrediant: ["Oats", "Eggs", "Whole wheat", "Beef steak", "Milk", "Curd"],
  });

  function handleInputChange(event) {
    let value = event.target.value;
    let name = event.target.name;
    setFormData({ ...formData, [name]: value });




   
  }
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100vh",
        backgroundColor: "white",
      }}
    >
      {/* Sidebar */}
      <Box
        sx={{
          width: 500,
          backgroundColor: "#fff",
          borderRight: "1px solid #e0e0e0",
          height: "100%",
          padding: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Products
        </Typography>
        <Divider />
        <List>
          {sidebarItems.map((item, index) => (
            <ListItemButton
              key={index}
              onClick={() => handleListItemClick(index)}
              sx={{
                backgroundColor:
                  selectedIndex === index ? "white" : "transparent",
                boxShadow: selectedIndex === index ? 1 : "none",
                border: selectedIndex === index ? "1px solid #0072DA" : "none",
                color: selectedIndex === index ? "#0072DA" : "black",
                "&:hover": {
                  backgroundColor: "#cce6ff", // Slight hover effect
                },
                borderRadius: "8px", // Optional: Rounded corners
              }}
            >
              <ListItemText
                primary={item.length > 18 ? `${item.slice(0, 18)}...` : item}
                sx={{
                  fontWeight: selectedIndex === index ? "bold" : "normal", // Bold for selected item
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          overflowY: "auto",
          maxHeight: "100%",
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: "20px", fontWeight: "bold", color: "#333" }}
        >
          Product
        </Typography>

        <Grid container sm={12} md={12} lg={12} xl={12} spacing={0}>
          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"name"}
              label={"Product Name"}
              value={productDetail.name}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"brandName"}
              label={"Brand Name"}
              value={productDetail.brandName}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              name={"address"}
              label={"Product Category"}
              value={productDetail.productCategory}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              multiline={true}
              name={"productDescription"}
              label={" Product description"}
              value={productDetail.productDescription}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <EditableTextField
              multiline={true}
              name={"line"}
              label={" Product Application"}
              value={productDetail.productApplication}
              isEdit={isEdit}
            />
          </Grid>

          <Grid item md={6} sx={{ p: 1, m: 0 }}>
            <CustomFileUpload
              fileType={"image"}
              name={"line"}
              label={"Product Appearance"}
              value={""}
              isEdit={isEdit}
              onChange={(e) => {}}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <EditableMultiSelectField
              name={"rowMaterial"}
              options={[
                "Oats",
                "Eggs",
                "Whole wheat",
                "Beef steak",
                "Milk",
                "Curd",
              ].map((option) => {
                return { value: option, label: option };
              })}
              label={"InGrediant"}
              value={formData.ingrediant}
              isEdit={isEdit}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <EditableMultiSelectField
              name={"solvent"}
              options={[
                "Oats",
                "Eggs",
                "Whole wheat",
                "Beef steak",
                "Milk",
                "Curd",
              ].map((option) => {
                return { value: option, label: option };
              })}
              label={"InGrediant"}
              value={formData.ingrediant}
              isEdit={isEdit}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <EditableMultiSelectField
              name={"excepients"}
              options={[
                "Oats",
                "Eggs",
                "Whole wheat",
                "Beef steak",
                "Milk",
                "Curd",
              ].map((option) => {
                return { value: option, label: option };
              })}
              label={"InGrediant"}
              value={formData.excepients}
              isEdit={isEdit}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item md={12} sx={{ p: 1, m: 0 }}>
            <EditableMultiSelectField
              name={"missleneous"}
              options={[
                "Oats",
                "Eggs",
                "Whole wheat",
                "Beef steak",
                "Milk",
                "Curd",
              ].map((option) => {
                return { value: option, label: option };
              })}
              label={"InGrediant"}
              value={formData.ingrediant}
              isEdit={isEdit}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>

        <Grid
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <CustomSecondaryButton label={"Back"} sx={{ margin: 2 }} />
          <CustomSuccessButton label={"Next"} />
        </Grid>
      </Box>
    </Box>
  );
};

export default ProductSpecification;
